import React, { useRef, useState } from 'react'
import { Image } from "react-bootstrap"
import { ImAttachment } from "react-icons/im";

import SimpleLoad from "../../loader/SimpleLoad";

export const UploadImage = ({ 
    title = 'Imágen', 
    validExtencions = ['image/png','image/svg+xml','image/jpg','image/jpeg'],
    imageDefault,
    field='url_photo',
    setFieldValue
}) => {
    const fileInputField = useRef(null);
    const [errorFile, setErrorFile] = useState(null)
    const [loading, setLoading] = useState(false)
    const [image, setImage] = useState(imageDefault)

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file)
          fileReader.onload = () => {
            resolve(fileReader.result);
          }
          fileReader.onerror = (error) => {
            reject(error);
          }
        })
      }

    const handleNewFileUpload = async (e) => {
            const file = e.target.files[0];

            if(file){
                const fileType = file.type.toLowerCase()

                if( !validExtencions.includes(fileType) ){
                    setErrorFile("Tipo de documento no válido")
                    console.log(fileType)
                } else {
                    setErrorFile(null)
                    setLoading(true)
                    setLoading(false)
                    const image64 = await convertBase64(file)
                    setImage(image64)
                    const base64 = image64.split(',')[1]

                    switch (field) {
                        case 'url_photo':
                            setFieldValue("url_photo", base64)
                            break;
                        case 'url_signature':
                            setFieldValue("url_signature", base64)
                            break;
                        default:
                            break;
                    }
                }
            }
    };

    return ( <>
        { loading && <SimpleLoad /> }
        <button type="button" className={`btn-block btn-file` }>
            {
                image ? <>
                    <Image src={image} className={ (field==='url_photo') ? 'doctor-foto-img' :'doctor-img-signature'} />
                </> :<>
                    <label className="font-weight-bold-600 font-size-09rem d-block">{ title }</label>
                    <ImAttachment className="d-block m-auto color-989898 font-size-13rem"/>
                    <span className='d-block color-989898 font-size-09rem'>JPG, PNG o SVG</span>
                </>
            }
        </button>
        <input
            type="file"
            ref={ fileInputField }
            className="input-file"
            onChange={ handleNewFileUpload }
        /> 

        {errorFile && <small className="color-red">{errorFile}</small>}                   
    </> )
}
